package dev.krno.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import dev.krno.data.EventData
import dev.krno.rive.__krno
import kotlinx.browser.document
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLElement

@Composable
fun Venue() {
    Section(attrs = {
        id("venue")
        classes("wrap")
        style { property("padding-bottom", "56px") }
    }) {
        Div(attrs = { classes("venue") }) {
            Div {
                Div(attrs = {
                    classes("label")
                    style { property("margin-bottom", "14px") }
                }) { Text("Venue") }
                H2 { Text("STRV Brno Office") }
                P(attrs = { classes("addr") }) {
                    B { Text("Brno city centre") }
                }
                P(attrs = { classes("addr") }) {
                    Text(
                        "Full address and entry instructions arrive in your confirmation email a week before the meetup."
                    )
                }
                Div(attrs = {
                    classes("chips")
                    style { property("margin-top", "26px") }
                }) {
                    Span(attrs = { classes("chip") }) {
                        Span(attrs = { classes("ms") }) { Text("tram") }
                        Text("5 min from Hlavas")
                    }
                    Span(attrs = { classes("chip") }) {
                        Span(attrs = { classes("ms") }) { Text("accessible") }
                        Text("Step-free access")
                    }
                }
            }
            A(
                href = EventData.VENUE_MAPS_URL,
                attrs = {
                    classes("map")
                    attr("target", "_blank")
                    attr("rel", "noopener noreferrer")
                    attr("aria-label", "Open STRV Brno office in Google Maps")
                }
            ) {
                Div(attrs = { id("venue-map"); classes("map-canvas") })
                Div(attrs = { classes("map-open") }) {
                    Text("Open in Google Maps")
                    Span(attrs = { classes("map-open-arrow") }) { Text("→") }
                }
            }
        }
    }

    DisposableEffect(Unit) {
        val container = document.getElementById("venue-map") as? HTMLElement
        val disposer: dynamic = if (container != null) {
            __krno.mountVenueMap(container, EventData.VENUE_LON, EventData.VENUE_LAT)
        } else null
        onDispose {
            if (disposer != null) (disposer as () -> Unit).invoke()
        }
    }
}
